import { render, staticRenderFns } from "./LinkedinAuthorizationHelper.vue?vue&type=template&id=a0a9392a"
import script from "./LinkedinAuthorizationHelper.vue?vue&type=script&lang=js"
export * from "./LinkedinAuthorizationHelper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports